module.exports = __webpack_public_path__ + "static/img/photo-1574834892631-f773d4c7f3e7.e502d27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/photo-1574834892631-f773d4c7f3e7.jpg
// module id = sIrf
// module chunks = 1